









































































import Vue, { PropType } from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { UseService } from '@/services/service';
import BulletinCommentService from '@/services/bulletin-comment.service';
import { ValidationObserver } from 'vee-validate';
import { BulletinCommentEntity } from '@/entities/bulletin-comment.entity';

@Component<EditBulletinComment>({})
export default class EditBulletinComment extends Vue {
  $refs!: {
    form: InstanceType<typeof ValidationObserver>;
  };

  BulletinCommentPayload: Partial<BulletinCommentEntity> = {
    content: null,
  };

  @Prop({ type: Boolean })
  value: boolean;

  @Prop({ type: Object as PropType<BulletinCommentEntity> })
  comment: BulletinCommentEntity;

  @Watch('value')
  async onPropertyChanged() {
    await this.$nextTick();
    this.$refs.form.reset();
    this.BulletinCommentPayload.content = this.comment.content;
  }

  async created(): Promise<void> {
    this.BulletinCommentPayload.content = this.comment.content;
  }

  @UseService(BulletinCommentService)
  service: BulletinCommentService;

  async editIssue(): Promise<void> {
    await this.service.updateOne(this.comment.id, this.BulletinCommentPayload);
    this.$refs.form.reset();
    this.$emit('input', !this.value);
  }

  async deleteIssue(): Promise<void> {
    await this.service.deleteOne(this.comment.id);
  }
}
